export const parseJwtSubject = (token) => {
  if (!token || typeof token !== 'string') return null;

  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    let normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const pad = normalized.length % 4;
    if (pad) {
      normalized += '='.repeat(4 - pad);
    }
    const decoded = JSON.parse(atob(normalized));
    return decoded.sub || null;
  } catch {
    return null;
  }
};

export const getTabSessionUserKey = () => parseJwtSubject(localStorage.getItem('token'));
